import clsx from 'clsx';
import styles from './index.module.css';

export const Step = ({ 
  number, 
  title, 
  status, 
  children, 
  isLast = false 
}) => {

  const cls = {
    step: clsx(
      styles.step,
      status === 'active' && styles['is-active'],
      status === 'complete' && styles['is-complete'],
      status === 'disabled' && styles['is-disabled'],
      status === 'success' && styles['is-success'],
    ),
    connector: clsx(
      styles.connector,
      status === 'complete' && styles['is-complete']
    )
  }

  return (
    <>
      <div className={cls.step}>
        <div className={styles.inner}>
          {status !== 'success' && (
            <span className={styles.icon}>
              {status === 'complete' ? (
                <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5.34783L6.05556 11L15 1" stroke="white" stroke-width="2"/>
                </svg>

              ) : number}
            </span>
          )}
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.content}>
            {children}
          </div>
        </div>
      </div>
      {!isLast && <span className={cls.connector}></span>}
    </>
  );
}